import type { ComponentProps } from "react";
import dynamic from "next/dynamic";
import type {
  SanityCubeExperienceHero,
  SanityPageBuilderCubeExperienceSection,
  SanityPageBuilderSection,
} from "@ouster/shared";

import { adaptCubeExperienceHero } from "~/features/sanity/hero/adapter";

// The cube uses three.js — keep it out of the initial bundle (matches the
// dynamic import used by the legacy hero pipeline).
const CubeExperienceHero = dynamic(
  () => import("~/features/hero/cube-experience-hero").then((mod) => mod.CubeExperienceHero),
  { ssr: false }
);

type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderCubeExperienceSection;
  };
};

export function SanityCubeExperienceSection({ section }: Props) {
  const { sectionContent } = section;

  // Section and hero share an identical field shape — reuse the hero adapter
  // to produce the Craft-typed data the CubeExperienceHero component
  // consumes via its GraphQL fragment.
  const asHero: SanityCubeExperienceHero = {
    ...sectionContent,
    _type: "cubeExperienceHero",
  };
  // The adapter returns the loosely-typed `CraftHeroData`; the component reads
  // it through its GraphQL fragment type. Same cast the hero pipeline uses
  // (see `features/sanity/hero/index.tsx`).
  const data = adaptCubeExperienceHero(asHero) as unknown as ComponentProps<typeof CubeExperienceHero>;

  return <CubeExperienceHero {...data} />;
}
